<template>
    <framed-layout>

        <template #center>
            <h3 class="font-bold">Kontrollkood</h3>
        </template>

        <template #right>
            <router-link to="/login" class="btn-circle">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <div class="max-w-4xl mx-auto text-center">
            <h1 class="text-2xl font-bold leading-tight md:text-4xl lg:text-5xl">Sinu kontrollkood:</h1>

            <h2 class="my-10 text-6xl md:text-9xl md:my-16 lg:my-24">{{ verificationCode }}</h2>

            <p class="max-w-sm mx-auto mb-20 md:text-lg">
                Sulle on telefonile saadetud kontrollkood, kontrolli vastavust
            </p>

            <router-link to="/login" class="text-sm font-semibold uppercase hover:underline"
            >Tühista
            </router-link>
        </div>
    </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import AuthService from '../services/auth.service';
import {poll} from "@/store/login.api";

export default {
    components: {
        FramedLayout
    },
    metaInfo: {
        title: 'Kontrollkood',
        meta: [
            { property: 'og:title', content: 'Kontrollkood' },
            { property: 'robots', content: 'index, follow' },
        ]
    },
    data() {
        return {
            polling: null,
            verificationCode: '',
            success: false,
        }
    },
    mounted() {
        if(this.$route.query?.verificationCode) {
            this.verificationCode = this.$route.query.verificationCode;
            const params = this.$route.query;
            poll(params).then(({data}) => {
                if(data?.message) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            message: data.message,
                        },
                    });
                } else {
                    AuthService.login(data?.token);
                    if (data?.isNewUser) {
                      this.$router.push('/terms-of-use/accept');
                    } else {
                      this.$router.push('/projects');
                    }
                }
            });
        } else {
            this.$router.push('/login');
        }
    }
}
</script>
